import StreamSaver from 'streamsaver';

/**
 * @usage
    useLoadingStore().showLoading("Đang tải xuống...");
    const url = `${AppConfig.adminApiProdUrl}/flycam/mosaic/download/${mosaicImage.id}`;
    const filename = `${mosaicImage.originalname}`;
    await StreamSaverUtils.download(url, filename);
    useLoadingStore().hideLoading();
 */
export const StreamSaverUtils = {
  download: async (url: string, filename: string) => {
    const token = localStorage.jwt;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`, // Add the Bearer token
      },
    });
    const contentLength = response.headers.get('content-length');
    const readableStream = response.body;

    const fileStream = StreamSaver.createWriteStream(filename, {
      size: contentLength != null ? Number(contentLength) : undefined,
    });

    if (!readableStream) {
      console.error('Empty body from', url);
      return;
    }

    if (window.WritableStream && readableStream.pipeTo) {
      return readableStream
        .pipeTo(fileStream)
        .then(() => {
          console.log('Download complete.');
        })
        .catch((err) => {
          return;
        });
    }

    const reader = readableStream.getReader();
    const writer = fileStream.getWriter();
    window.onbeforeunload = (e) => {
      writer.abort();
    };

    const pump = () =>
      reader.read().then((res) => {
        if (res.done) {
          writer.close();
          return;
        }
        writer.write(res.value).then(pump);
      });

    pump();
  },
};
